import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagSX = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M22.826 27.174S7.337 7.319 7.322 7.322A24.922 24.922 0 0 1 25 0c13.807 0 25 11.193 25 25l-27.174 2.174Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M22.826 25S7.337 42.68 7.322 42.678A24.921 24.921 0 0 0 25 50c13.807 0 25-11.193 25-25H22.826Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M7.322 7.322c-9.763 9.763-9.763 25.592 0 35.356L25 25 7.322 7.322Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M2.74 25a7.065 7.065 0 1 0 14.085 0H2.74ZM9.782 21.74a2.174 2.174 0 1 0 0-4.349 2.174 2.174 0 0 0 0 4.348Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M4.892 19.021v7.066c0 3.744 4.89 4.89 4.89 4.89s4.892-1.146 4.892-4.89V19.02H4.892Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#338AF3",
  d: "M9.785 28.703c-.908-.326-2.72-1.161-2.72-2.616v-4.891H12.5v4.89c0 1.46-1.813 2.293-2.715 2.617Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F3F3F3",
  d: "M10.87 23.913v-1.087l-1.087-.543-1.087.543v1.087l-.544.544v2.174h3.261v-2.174l-.543-.544Z"
}));
FlagSX.displayName = 'FlagSX';
export default withFlagWrapper(FlagSX);
//# sourceMappingURL=index.js.map